
import { defineComponent } from "vue";
import AppSubMenuLink from "./AppSubMenuLink.vue";

export default defineComponent({
  components: {
    AppSubMenuLink,
  },
  props: {
    menuItems: Array,
  },
  emits: ['clicked-item'],
  methods: {
    onItemClicked(event: Event)
    {
      this.$emit('clicked-item', event)
    }
  }
});
